<template>
  <div v-if="!seriesPreselected">
    <FormSection title="">
      <div class="styled-radio-container--ou-donation main-selector">
        <div class="radio-part">
          <input
            id="type_daily"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'daily'"
            @click="setValue('custom.sponsorshipType', 'daily')"
          />
          <FormLabel for="type_daily"> Parnes Hayom </FormLabel>
        </div>
        <div class="radio-part">
          <input
            id="type_weekly"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'series'"
            @click="setValue('custom.sponsorshipType', 'series')"
          />
          <FormLabel for="type_weekly"> Sponsor a Shiur </FormLabel>
        </div>
        <div class="radio-part">
          <input
            id="type_gen"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'general'"
            @click="setValue('custom.sponsorshipType', 'general')"
          />
          <FormLabel for="type_gen"> General Donation </FormLabel>
        </div>
      </div>
      <ErrorLabel field="custom.sponsorshipType" />
    </FormSection>

    <!-- daily -->
    <template v-if="getValue('custom.sponsorshipType') == 'daily'">
      <div class="donation-type">
        <FormSection title="Donation Date">
          <FormRow inline style="max-width: 50%; margin-bottom: 10px">
            <input
              type="date"
              class="date-input"
              @change="setDailyDate(new Date($event.target.value))"
            />
          </FormRow>
          <div>
            <FormLabel
              >Dedicate a day of learning across the platform -
              <b
                ><MoneyFormat
                  class="label-amount"
                  :value="500"
                  :currencyCode="form.currency || 'USD'"
                  :hide-subunits="true" /></b
            ></FormLabel>
          </div>
          <div>
            <FormLabel>
              <b>Name will be displayed across the app and website.</b></FormLabel
            >
          </div>

          <div><ErrorLabel field="custom.startDate" /></div>
          <div style="margin-bottom: 20px">
            <FormLabel
              >
              <div style=" text-align: center;">For naming and other special dedications please contact Moshe Schwed at 
              <a href="mailto:schwedm@ou.org">schwedm@ou.org</a></div></FormLabel
            >
          </div>
        </FormSection>
      </div>
    </template>

    <!-- series -->
    <!-- Debug: sponsorshipType = {{ getValue('custom.sponsorshipType') }} -->
    <template v-else-if="getValue('custom.sponsorshipType') == 'series'">
      <div class="donation-type donation--fancy donation--col">
        <div class="series__type">
          <FormLabel for="dafomi_type">
            <input
              id="dafomi_type"
              type="radio"
              :checked="getValue('custom.seriesType') == 'dafyomi'"
              @click="setValue('custom.seriesType', 'dafyomi'); setValue('amount', '250'); donationShiurType = 'day'"
            />
            Daf Yomi Shiurim
          </FormLabel>

          <FormLabel for="suplemtal_type">
            <input
              id="suplemtal_type"
              type="radio"
              :checked="getValue('custom.seriesType') == 'supplemental'"
              @click="setValue('custom.seriesType', 'supplemental'); setValue('amount', '250'); donationShiurType = 'day'"
            />
            Supplemental Clips
          </FormLabel>

          <FormLabel for="refrefence_type">
            <input
              id="refrefence_type"
              type="radio"
              :checked="getValue('custom.seriesType') == 'reference'"
              @click="setValue('custom.seriesType', 'reference'); setValue('amount', '250'); donationShiurType = 'day'"
            />
            Reference Materials
          </FormLabel>
        </div>

        <FormRow v-if="getValue('custom.seriesType') == 'dafyomi'">
          <FormSelect field="custom.programId" style="flex: 1; margin-right: 10px">
            <option :value="null">Select a Shiur</option>
            <option v-for="shiur of yomis" :key="shiur.id" :value="shiur.id">
              {{ shiur.name }}
            </option>
          </FormSelect>
        </FormRow>

        <FormRow v-if="getValue('custom.seriesType') == 'supplemental'">
          <FormSelect field="custom.programId" style="flex: 1; margin-right: 10px">
            <option :value="null">Select a Shiur</option>
            <option v-for="shiur of supplemental" :key="shiur.id" :value="shiur.id">
              {{ shiur.name }}
            </option>
          </FormSelect>
        </FormRow>

        <FormRow v-if="getValue('custom.seriesType') == 'reference'">
          <FormSelect field="custom.programId" style="flex: 1; margin-right: 10px">
            <option :value="null">Select a Shiur</option>
            <option v-for="shiur of references" :key="shiur.id" :value="shiur.id">
              {{ shiur.name }}
            </option>
          </FormSelect>
        </FormRow>
        <ErrorLabel field="custom.programId" />

        <FormSection title="Donation Amount">
          <!-- daf yomi amounts -->
          <div
            class="styled-radio-container--ou-donation type-selector"
            v-if="getValue('custom.seriesType') == 'dafyomi'"
          >
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-day"
                :checked="donationShiurType == 'day'"
                @click="
                  () => {
                    donationShiurType = 'day';
                  }
                "
              />
              <label for="donationShiurType-day"
                ><b>Day</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="250"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-week"
                :checked="donationShiurType == 'week'"
                @click="
                  () => {
                    donationShiurType = 'week';
                  }
                "
              />
              <label for="donationShiurType-week"
                ><b>Week</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="1800"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-month"
                :checked="donationShiurType == 'month'"
                @click="
                  () => {
                    donationShiurType = 'month';
                  }
                "
              />
              <label for="donationShiurType-month"
                ><b>Month </b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="5000"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
          </div>
          <!-- regualr amounts -->
          <div class="styled-radio-container--ou-donation type-selector" v-else>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-day"
                :checked="donationShiurType == 'day'"
                @click="
                  () => {
                    donationShiurType = 'day';
                  }
                "
              />
              <label for="donationShiurType-day"
                ><b>Day</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="250"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-week"
                :checked="donationShiurType == 'week'"
                @click="
                  () => {
                    donationShiurType = 'week';
                  }
                "
              />
              <label for="donationShiurType-week"
                ><b>Week</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="1800"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-month"
                :checked="donationShiurType == 'month'"
                @click="
                  () => {
                    donationShiurType = 'month';
                  }
                "
              />
              <label for="donationShiurType-month"
                ><b>Month </b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="5000"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
          </div>
        </FormSection>

        <div class="donation-type">
          <FormSection title="Donation Date">
            <FormRow inline style="max-width: 50%; margin-bottom: 10px">
              <input
                type="date"
                class="date-input"
                @change="setDailyDate(new Date($event.target.value))"
                v-if="donationShiurType == 'day'"
              />
              <input
                type="date"
                class="date-input"
                @change="setDate(new Date($event.target.value))"
                v-else-if="donationShiurType == 'week'"
              />
              <input
                type="month"
                class="date-input"
                @change="setMonthDate(new Date($event.target.value))"
                v-else
              />
            </FormRow>
            <ErrorLabel field="custom.startDate" />

            <div style="margin-bottom: 20px">
              <FormLabel
                >For naming and other special dedications please contact
                <a href="mailto:dafinfo@alldaf.org">dafinfo@alldaf.org</a></FormLabel
              >
            </div>
          </FormSection>
        </div>
      </div>
    </template>

    <template v-else-if="getValue('custom.sponsorshipType') == 'general'">
      <div class="donation-type general">
        <AmountSelector defaultCheckedAount="360"/>
      </div>
      <div style="margin-bottom: 20px">
        <div class="alltorah__honor">* Join the All Torah, All Year 360 Scroll of Honor</div>
        <FormLabel
          >General donations are <b>not</b> shown on the app and website.</FormLabel
        >
      </div>
    </template>
  </div>
  <div v-else>
    <h1 class="sponsor"><span>Sponsor Series</span>{{ selectedSeries }}</h1>
    <div class="donation-type general">
      <div class="note">$500 donation and above entitles you to a Shiur dedication</div>
      <AmountSelector />
      <FormRow inline style="max-width: 50%" v-if="showDedicationAndDate">
        <input
          type="date"
          class="date-input"
          @change="setDate(new Date($event.target.value))"
        />
      </FormRow>

      <ErrorLabel field="custom.startDate" />
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  computed,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

defineProps<{
  seriesPreselected?: boolean
  showDedicationAndDate?: boolean
}>();

const { setValue, getValue, form, testMode } = usePaymentForm();

    const shiurim = ref([]);
    const yomis = ref([]);
    const references = ref([]);
    const supplemental = ref([]);

    const donationShiurType = ref<string | null>(null);
    const isInitialized = ref(false);
    const isProcessingTypeChange = ref(false);
    setValue("amount", "360");
    
    watch(
      () => getValue("custom.sponsorshipType"),
      () => {
        if (!isInitialized.value || isProcessingTypeChange.value) return;

        isProcessingTypeChange.value = true;
        if (getValue("custom.sponsorshipType") == "weekly") {
          setValue("amount", "720");
          setValue("applications.0.campaign", "All Daf");
        } else if (getValue("custom.sponsorshipType") == "daily") {
          setValue("amount", "500");
          setValue("custom.dateOption", "Day");
          setValue("custom.seriesType", null);
          setValue("applications.0.campaign", "All Daf");
        } else {
          setValue("amount", null);
          setValue("applications.0.campaign", "All Daf");
        }

        setValue("custom.programId", null);

        donationShiurType.value = null;

        if (getValue("custom.sponsorshipType") == "general") {
          setValue("custom.seriesType", null);
          setValue("custom.startDate", null);
          setValue("custom.endDate", null);
          setValue("custom.dateOption", null);
          setValue("applications.0.campaign", "All Daf");
        }

        if (getValue("custom.sponsorshipType") == "series") {
          setValue("custom.startDate", null);
          setValue("custom.endDate", null);
          setValue("applications.0.campaign", "All Daf");
        }

        isProcessingTypeChange.value = false;
      }
    );

    watch(donationShiurType, () => {
      // special daf prices
      if (getValue("custom.seriesType") == "dafyomi") {
        if (donationShiurType.value == "day") {
          setValue("amount", "250");
          setValue("custom.dateOption", "Day");
        }
        if (donationShiurType.value == "week") {
          setValue("amount", "1800");
          setValue("custom.dateOption", "Week");
        }
        if (donationShiurType.value == "month") {
          setValue("amount", "5000");
          setValue("custom.dateOption", "Month");
        }
      } else {
        if (donationShiurType.value == "day") {
          setValue("amount", "250");
          setValue("custom.dateOption", "Day");
        }
        if (donationShiurType.value == "week") {
          setValue("amount", "1800");
          setValue("custom.dateOption", "Week");
        }
        if (donationShiurType.value == "month") {
          setValue("amount", "5000");
          setValue("custom.dateOption", "Month");
        }
      }
    });

    const selectedSeries = computed(() => {
      //@ts-ignore
      const foundSeries = shiurim.value.find((x) => x.id == getValue("custom.programId"));
      //@ts-ignore
      const foundYomi = yomis.value.find((x) => x.id == getValue("custom.programId"));
      //@ts-ignore
      const foundReferences = references.value.find(
        //@ts-ignore
        (x) => x.id == getValue("custom.programId")
      );
      //@ts-ignore
      const foundSupplemental = supplemental.value.find(
        //@ts-ignore
        (x) => x.id == getValue("custom.programId")
      );

      //@ts-ignore
      if (foundSeries) return foundSeries.name;

      //@ts-ignore
      if (foundYomi) return foundYomi.name;

      //@ts-ignore
      if (foundReferences) return foundReferences.name;

      //@ts-ignore
      if (foundSupplemental) return foundSupplemental.name;

      return null;
    });

    watch(selectedSeries, (selectedSeries) => {
      setValue("applications.0.subCampaign", selectedSeries);
    });

    onMounted(() => {
      if (!getValue("custom.sponsorshipType")) {
        setValue("custom.sponsorshipType", "general");
      }
      if (!getValue("applications.0.campaign")) {
        setValue("applications.0.campaign", "All Daf");
      }

      isInitialized.value = true;

      fetch(
        testMode
          ? "https://outorah.oudev.org/allDafSeries"
          : "https://outorah.org/allDafSeries"
      )
        .then((x) => x.json())
        .then((x) => {
          // Prod returns allDafType with underscores ("Daf_Yomi_Shiurim"),
          // staging with spaces ("Daf Yomi Shiurim"); normalize before filtering.
          const typeOf = (item: any) =>
            (item.allDafType || "").replace(/_/g, " ");
          x = x.map((item: any) => ({ ...item, allDafType: typeOf(item) }));
          shiurim.value =
            x.filter((x: any) => x.allDafType == "Supplemental Clips") ||
            (x.filter((x: any) => x.allDafType == "Reference Materials") &&
              x.filter((x: any) => x.allDafType != "Daf Yomi Shiurim"));
          yomis.value = x.filter((x: any) => x.allDafType == "Daf Yomi Shiurim");
          references.value = x.filter((x: any) => x.allDafType == "Reference Materials");
          supplemental.value = x.filter((x: any) => x.allDafType == "Supplemental Clips");
        });
    });

const currency = computed(() => form.value.currency);

const setDate = (date: Date) => {
  setValue(
    "custom.startDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    ).toISOString()
  );
  setValue(
    "custom.endDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 6)
    ).toISOString()
  );
};

const setDailyDate = (date: Date) => {
  setValue(
    "custom.startDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    ).toISOString()
  );
  setValue(
    "custom.endDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
    ).toISOString()
  );
};

const setMonthDate = (date: Date) => {
  //needs to be updated to first and end of month
  setValue(
    "custom.startDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    ).toISOString()
  );
  setValue(
    "custom.endDate",
    new Date(
      Date.UTC(date.getFullYear(), date.getMonth() + 1, date.getDate())
    ).toISOString()
  );
};


</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  &.type-selector {
    justify-content: center;
    gap: 0px 5px;
  }
  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 33.33333%;
      flex: 1;
      padding-left: 0;
      max-width: 33.33333%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  ::v-deep label {
    padding: 15px;
    background: #fff;
    line-height: 1.4;
    border: 1px solid #93a9c1;
    color: #2e343c;
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: #99badd;
    color: #ffffff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    margin-bottom: 0px !important;
    input[type="number"] {
      background: #fff;
      margin-top: -15px;
    }
  }
}

//type selector
.type-selector,
.main-selector {
  .radio-part {
    min-width: 33.333%;
    max-width: 33.333%;
    text-transform: uppercase;
    font-size: 13px;
  }
}

//amount selector
.donation-type.general {
  ::v-deep .styled-radio--ou-donation.styled-radio {
    label {
      border: 1px solid #93a9c1;
      color: #2e343c;
      font-weight: normal;
    }
    input[type="radio"]:checked + label {
      background: #99badd;
      color: #ffffff;
    }
  }
}
::v-deep .donation-type.donation--fancy,
::v-deep .type-selector {
  display: flex;
  align-items: center;
  justify-content: center;

  &.donation--col {
    flex-flow: column;
    justify-content: flex-start;
    align-items: baseline;
  }

  .radio__part {
    label {
      display: flex;
      flex-flow: column;
      border: 1px solid #93a9c1;
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      margin-right: 15px;
      flex-flow: column;
      cursor: pointer;
      padding: 2px 18px;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: #2e343c;
      font-size: 17px;
      &:hover {
        background: #e9f0f7;
      }
    }
    span {
      font-weight: 200;
    }
    input {
      height: 0;
      top: 20px;
      position: relative;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }

    input[type="radio"]:checked + label {
      background: #99badd !important;
      color: #ffffff;
    }
  }
}
hr {
  margin-bottom: 20px;
}
::v-deep .money_format {
  display: inline;
}
::v-deep h2 {
  font-size: 19px;
  margin-bottom: 14px;
  font-weight: bold;
  margin-top: 13px;
}

h1.sponsor {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
  letter-spacing: -1px;
  font-size: 28px;
  line-height: 1.4;
  margin-top: 20px;
  span {
    display: block;
    font-size: 14px;
    text-transform: uppercase;
    color: #999;
  }
}
.note {
  margin-bottom: 15px;
  background: #348dff1a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #d8e2ec;
}
.series__type {
  width: 100%;
  margin-top: 12px;
  display: flex;
  flex-flow: wrap;
  margin-bottom: 20px;
  label {
    flex: 1;
    display: flex;
    gap: 6px;
    align-items: center;
  }
  input {
    width: auto;
    margin: 0px;
  }
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}

  ::v-deep
.styled-radio.styled-radio--ou-donation.row 
  input[type="radio"]
  + label[data-amount="360"] {
  &:after {
    content: "*";
    font-size: 11px;
    padding-left: 2px;
  }
}

.alltorah__honor{
  font-size: 14px;
  padding-bottom: 15px;
}
</style>
